<script>
import Layout from '@layouts/main';
import LocationForm from '@views/locations/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'LocationEdit',
  components: {
    Layout,
    LocationForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    areas: {
      required: true,
      type: Array,
      default: null,
    }
  },
  page() {
    return {
      title: `${this.$t('titles.edit_location')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.locations'),
          to: { name: 'locations.index' },
        },
        {
          text: `${this.$t('titles.edit_location')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update(callback) {
      this.setUnchanged();
      if (!callback) {
        this.$router.push({
          name: 'locations.index',
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_location')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <LocationForm :loaded-id="$route.params.id" :areas="areas" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
